module.exports = __webpack_public_path__ + "media/images/lb/675-285d052f56c868e28f087c17a8f98c57.svg";